import VisibilityIcon from "@mui/icons-material/Visibility";
import { IconButton } from "@mui/material";
import React from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { ModalComponent } from "../../../../../ui-components/Modal";
import { parseDateLocale } from "../../../../../utils/parseDate";
import { adminButtonOutlinedSx } from "../../../../AdminDashboard/modalStyle";

// estilo antigo removido: adminModalSx é o padrão

interface Event {
  active: boolean;
  cover: string;
  created_at: Date;
  description: string;
  ends_at: Date;
  name: string;
  updated_at: Date;
  starts_at: Date;
  id: number;
  limitdate: Date;
}

export default function ViewButton({
  id,
  updateEvents,
  event,
}: {
  id: number;
  updateEvents: Function;
  event: Event;
}) {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { starts_at, ends_at, limitdate } = event;
  const toISODate = (value: Date) => {
    try {
      return new Date(value).toISOString().slice(0, 10);
    } catch {
      return "";
    }
  };

  return (
    <>
      <ModalComponent
        open={open}
        handleClose={handleClose}
        title="Ver Evento"
        autoHeight
      >
        <Box sx={{ px: 1, py: 1 }}>
          <p>ID: {event.id}</p>
          <p>Nome: {event.name}</p>
          <p>Descrição: {event.description}</p>
          <p>Evento ativo: {event.active ? "Sim" : "Não"}</p>
          <p>Data de início: {parseDateLocale(toISODate(starts_at))}</p>
          <p>Data de Término: {parseDateLocale(toISODate(ends_at))}</p>
          <p>
            Data de limite para pagamento:{" "}
            {parseDateLocale(toISODate(limitdate))}
          </p>
          <Box sx={{ pt: 2, display: "flex", justifyContent: "flex-end" }}>
            <Button
              onClick={handleClose}
              variant="outlined"
              sx={adminButtonOutlinedSx}
            >
              Fechar
            </Button>
          </Box>
        </Box>
      </ModalComponent>
      <IconButton title="Pressione 2 vezes para ver mais" onClick={handleOpen}>
        <VisibilityIcon />
      </IconButton>
    </>
  );
}
